import AppApi from "./AppApi";
import AppStore from "../stores/Store";

export default class SettingsApi {
  constructor(private api: AppApi, private store: AppStore) {
    this.api = api;
    this.store = store;
  }
  
  async linkExternalService(
    userId: string,
    accessToken: string,
    refreshToken: string,
    accessTokenSecret: string,
    providerIdentifier: string,
    service: string,
    shortToken: string | null = null) {
    if (this.store.settingsStore.isLinkStarted()) {
      return;
    }
    
    const token = await this.store.authStore.getAuthToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const url = this.getLinkUrl(token, shortToken);
    
    this.store.settingsStore.setLinkStarted(true);
    await this.api.client.post(
      url,
      {
        userId: userId,
        accessToken: accessToken,
        accessTokenSecret: accessTokenSecret,
        refreshToken: refreshToken,
        providerIdentifier: providerIdentifier,
        providerName: service
      },
      config
    );
    this.store.settingsStore.setLinkStarted(false);
    
    this.store.authStore.addService(service);
  }
  
  getLinkUrl(token: string, shortToken: string | null) {
    const base = '/auth/api/v1/external/services/link';
    const params = !token && shortToken
      ? `?short_token=${encodeURIComponent(shortToken)}`
      : ''
    return `${base}${params}`;
  }
  
  async removeExternalService(service: string, shortToken: string | null = null) {
    if (this.store.settingsStore.isLinkStarted()) {
      return;
    }
    
    const token = await this.store.authStore.getAuthToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const url = token ? '/auth/api/v1/external/services/unlink' :
      shortToken ? `/auth/api/v1/external/services/unlink?short_token=${encodeURIComponent(shortToken)}` :
        '/auth/api/v1/external/services/unlink';
    
    this.store.settingsStore.setLinkStarted(true);
    await this.api.client.post(
      url,
      {
        providerName: service
      },
      config
    );
    this.store.settingsStore.setLinkStarted(false);
    this.store.authStore.removeService(service);
  }
  
  close() {
    this.store.settingsStore.close();
  }
  
  open() {
    this.store.settingsStore.open();
  }
}